<template>
<div>
</div>
</template>

<script>
import { clearToken } from 'functions/auth_check.js'
import axios from 'axios'

export default {
	// Normale Eigenschaften
	data () {
		return {}
	},

	activated () {
		axios.delete('/api/session/')
		.then(() => {
			clearToken()
			this.$router.replace('/')
		})
	}
}
</script>



// WEBPACK FOOTER //
// LogoutView.vue?df2f94f8